module.exports = __webpack_public_path__ + "static/img/wechat-QRCode.fc5866e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechat-QRCode.png
// module id = nD6H
// module chunks = 23